import { Link } from 'react-router-dom';

const LINK_PATTERN = /\[\[([^\]|]+)\|([^\]]+)\]\]/g;

const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

export function renderArticleText(text: string) {
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  const regex = new RegExp(LINK_PATTERN.source, 'g');

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const label = match[1];
    const href = match[2];

    parts.push(
      <Link key={`link-${key++}`} to={href} style={articleLinkStyle}>
        {label}
      </Link>
    );

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : text;
}
